// extracted by mini-css-extract-plugin
export default {"loading":"u1XfaTfFRAPBobgPaCgk"};